import { ItineraryImage } from './../itineray.model';
import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: 'app-itinerary-image-form-field',
  templateUrl: './itinerary-image-form-field.component.html',
  styleUrls: ['./itinerary-image-form-field.component.css']
})
export class ItineraryImageFormFieldComponent {

  @Input()
  image: ItineraryImage;

  @Output()
  imageChange = new EventEmitter<ItineraryImage>();

  @Input()
  itineraryId: string;

  @Input()
  label: string;

  @Input()
  disabled: boolean;

}
